import { CompanyBranchDetailPage } from 'pages/cls1/branch/detail/page'
import BranchPage from 'pages/cls1/branch/page'
import CompanyPage from 'pages/cls1/page'

export const cls1Routes = [
  { path: '/cls1/company/', element: <CompanyPage /> },
  { path: '/cls1/company/:id/branch/', element: <BranchPage /> },
  {
    path: '/cls1/company/:id/branch/:branchId',
    element: <CompanyBranchDetailPage />,
  },
]
